import React from 'react'

// when no image
import noImgFoundImg from 'assets/images/no-img.png'
import { Link } from 'react-router-dom'

export default function CartItems(props) {
    // props
    const { cartItems, cartImages } = props

    return (
        <div className="cart-list">
            <div className="table-responsive">
                <table className="table">
                    <tbody>
                        {
                            cartItems?.length ? cartItems.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="p-1">
                                            <Link to={`product/${item.product_name}?id=${item.product_id}`} className="d-flex flex-wrap text-black text-decoration-none st-fs-13 position-relative">
                                                <div className="img-sec position-relative" style={{ width: 45, top: 3 }}>
                                                    <img
                                                        src={cartImages[item.cart_id] || noImgFoundImg}
                                                        alt=""
                                                        className="img-fluid"
                                                        style={{ maxHeight: "100%" }}
                                                    />
                                                </div>
                                                <div className="text-sec media-body st-line-height-normal position-relative" style={{ paddingLeft: 5 }}>
                                                    <p className="mb-0 st-fw-600">{item.product_name}</p>
                                                    {
                                                        item.variant_name ? (
                                                            <React.Fragment>
                                                                {
                                                                    (item.variant_name.search(",") !== -1) && item.variant_name.split(",").map((item, index) => (
                                                                        <p key={index} className="mb-0">{item}</p>
                                                                    ))
                                                                }
                                                            </React.Fragment>
                                                        ) : null
                                                    }
                                                </div>
                                            </Link>
                                        </td>

                                        <td className="p-1">
                                            <p className="mb-0 st-fs-13">{item.quantity}x</p>
                                        </td>

                                        <td className="p-1">
                                            <p className="mb-0 st-fs-13 st-fw-600">{item.total_price}</p>
                                        </td>
                                    </tr>
                                )
                            }) : null
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}
